import React, { useState } from 'react';
import { ChevronDown, ChevronUp, User, Plus, X } from 'lucide-react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const PersonnelSection = ({ expanded, onToggle, formData, setFormData }) => {
  const [newPerson, setNewPerson] = useState({ name: '', role: '', id: '' });

  const addPerson = () => {
    if (newPerson?.name && newPerson?.role) {
      setFormData(prev => ({
        ...prev,
        personnelInvolved: [...prev?.personnelInvolved, { ...newPerson, key: Date.now() }]
      }));
      setNewPerson({ name: '', role: '', id: '' });
    }
  };

  const removePerson = (key) => {
    setFormData(prev => ({
      ...prev,
      personnelInvolved: prev?.personnelInvolved?.filter(p => p?.key !== key)
    }));
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50"
        onClick={onToggle}
      >
        <div className="flex items-center gap-3">
          <User className="w-5 h-5 text-blue-600" />
          <h2 className="text-lg font-semibold text-gray-900">Personnel Involved</h2>
        </div>
        {expanded ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
      </div>
      {expanded && (
        <div className="p-4 pt-0 border-t border-gray-200">
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <Input
                placeholder="Full Name"
                value={newPerson?.name}
                onChange={(e) => setNewPerson(prev => ({ ...prev, name: e?.target?.value }))}
              />
              <Input
                placeholder="Role/Position"
                value={newPerson?.role}
                onChange={(e) => setNewPerson(prev => ({ ...prev, role: e?.target?.value }))}
              />
              <div className="flex gap-2">
                <Input
                  placeholder="Employee ID (optional)"
                  value={newPerson?.id}
                  onChange={(e) => setNewPerson(prev => ({ ...prev, id: e?.target?.value }))}
                  className="flex-1"
                />
                <Button
                  type="button"
                  onClick={addPerson}
                  className="flex items-center gap-1"
                  disabled={!newPerson?.name || !newPerson?.role}
                >
                  <Plus className="w-4 h-4" />
                  Add
                </Button>
              </div>
            </div>

            {formData?.personnelInvolved?.length > 0 && (
              <div className="space-y-2">
                <h4 className="text-sm font-medium text-gray-700">Added Personnel:</h4>
                {formData?.personnelInvolved?.map((person) => (
                  <div 
                    key={person?.key} 
                    className="flex items-center justify-between bg-gray-50 rounded-lg p-3"
                  >
                    <div>
                      <p className="text-sm font-medium text-gray-900">{person?.name}</p>
                      <p className="text-xs text-gray-600">
                        {person?.role} {person?.id && `• ID: ${person?.id}`}
                      </p>
                    </div>
                    <button
                      type="button"
                      onClick={() => removePerson(person?.key)}
                      className="text-red-600 hover:text-red-800"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PersonnelSection;